import { API_BASE } from "config/api";
import { withAuthHeaders } from "services/authHeader";

export default async function getLangauges() {
  try {
    const url = new URL("api/languages/getLanguages", API_BASE);
    const res = await fetch(url, {
      method: "GET",
      headers: withAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    });

    const json = await res.json();
    if (json.status === "success") return json.data;
    throw new Error(json.message || "Failed to fetch languages");
  } catch (error) {
    console.error("Error in getLanguages:", error);
    throw error;
  }
}
